import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ServiceDetails.css";

const ServiceDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, longDesc } = location.state || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!title) {
    return (
      <div style={{ padding: "50px", textAlign: "center" }}>
        <h2>Service Not Found</h2>
        <button onClick={() => navigate("/services")}>Back to Services</button>
      </div>
    );
  }

  return (
    <div className="service-details-page">
      {/* ✅ Back Arrow Button inside banner */}
      <div className="service-banner">
        <button className="back-button" onClick={() => navigate("/services")}>
          ← Back
        </button>
        <h1 className="service-banner-text">Services</h1>
        <p className="service-banner-subtext">Explore what we offer</p>
      </div>

      <h2 className="details-heading">{title}</h2>
      <span className="details-underline"></span>

      <p className="details-description">{longDesc}</p>
    </div>
  );
};

export default ServiceDetails;
